import { render, staticRenderFns } from "./Edificios.vue?vue&type=template&id=7db0739c&"
import script from "./Edificios.vue?vue&type=script&lang=js&"
export * from "./Edificios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports